import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetCompanyStaticFormPathMutation } from 'store/features/auth/authApi';

const AppBootstrapper = ({ children }) => {
	const { profileData } = useSelector((state) => state?.profile);
	const [getCompanyStaticPath] = useGetCompanyStaticFormPathMutation();

	useEffect(() => {
		const companyCode = profileData?.creatorOrganizationId || localStorage.getItem('companyCode');
		if (companyCode) {
			getCompanyStaticPath({ companyCode });
		}
	}, [profileData?.creatorOrganizationId, getCompanyStaticPath]);

	return children;
};

export default AppBootstrapper;
